module.exports = __webpack_public_path__ + "img/IconCart-zeborne.471a2211.svg";